import type { Permission, ScopeDomain } from '@/types/models'

/**
 * Yönetim → Gruplar ekranının alan blokları (docs/GRUP-KAPSAM-PLAN.md Faz 3). Her blok o alanın
 * izinlerini ve kapsamını birlikte gösterir; iznin alanı backend kataloğundan gelir (`area`).
 */
export type AreaKey = ScopeDomain | 'other'

export const AREA_ORDER: readonly AreaKey[] = ['hr', 'finans', 'kantar', 'other']

/** İzinleri alanlarına ayırır; katalog sırası korunur, boş alan da (boş listeyle) yer alır. */
export function permissionsByArea(permissions: Permission[]): Map<AreaKey, Permission[]> {
  const areas = new Map<AreaKey, Permission[]>(AREA_ORDER.map((area) => [area, []]))
  for (const permission of permissions) {
    areas.get(permission.area ?? 'other')!.push(permission)
  }
  return areas
}

/** Alanın seçili izin sayısı. */
export function selectedCount(permissions: Permission[], selected: readonly string[]): number {
  return permissions.filter((permission) => selected.includes(permission.key)).length
}

/** Seçimin kaydedilen hâlden farkı (sıra önemsiz). */
export function sameSet(a: readonly string[], b: readonly string[]): boolean {
  return a.length === b.length && a.every((item) => b.includes(item))
}
